import { useParams } from 'react-router-dom';
import { useDbReportsGetOnlineInvoicesAndProducts } from '../../base/useDbReports';
import { DisplayInvoice } from './DisplayInvoice';

export function LastOnlineInvoicesList() {
  const { count } = useParams();
  const { last10OnlineInvoices, productsByOrderId } = useDbReportsGetOnlineInvoicesAndProducts(
    count ? Number(count) : 10,
  );

  return (
    <div className='p-4 space-y-6'>
      {last10OnlineInvoices.length === 0 ? (
        <div className='text-center text-gray-500 text-lg'>No invoices available.</div>
      ) : (
        last10OnlineInvoices.map((invoice) => (
          <DisplayInvoice
            key={'inv' + invoice.invoiceId}
            invoice={invoice}
            products={productsByOrderId[invoice.orderId ?? ''] || []}
          />
        ))
      )}
    </div>
  );
}